import './less/catalogs.less';

const Catalogs = function(){

};
const catalogs = new Catalogs();

export { catalogs };


// WEBPACK FOOTER //
// ./components/catalogs/catalogs.js